import { NumberishId, Polygon } from "../../model/type";
import ApiClient from "../api/ApiClient";
import { DataQueryParamsInterface } from "../../model/DataQueryParams";
import { OfferCreatorFilterParams } from "../../model/filter-params/OfferCreatorFilterParams";
import { UpdatableFields } from "../../action/updateManyAvailabilities";
import { PayloadGet } from "../api/Endpoint/Offers_Id_Availabilities";
import ContentType from "../api/ContentType";

export default class MediumAvailabilitiesDao {
    private apiClient: ApiClient;

    constructor(apiClient: ApiClient) {
        this.apiClient = apiClient;
    }

    public findAllForOffer(offerId: string, params: DataQueryParamsInterface<OfferCreatorFilterParams>): Promise<PayloadGet> {
        return this.apiClient.offers_Id_Availabilities.get<PayloadGet>(offerId, params)
            .then(response => response.data)
    }

    public findAllForOfferAsXlsx(offerId: string, params: DataQueryParamsInterface<OfferCreatorFilterParams>, extendedVersion?: boolean): Promise<File> {
        return this.apiClient.offers_Id_Availabilities.get<File>(
            offerId,
            params,
            ContentType.XLSX,
            extendedVersion
        ).then(response => response.data)
    }

    public acceptOrReject(mediumAvailabilityId: NumberishId, accepted: boolean): Promise<void> {
        const _command = accepted ? 'ACCEPT' : 'REJECT';
        return this.apiClient.mediumAvailabilities_Id.patch(mediumAvailabilityId, { _command })
            .then()
    }

    public toggleRecommended(mediumAvailabilityId: NumberishId | NumberishId[], recommended: boolean): Promise<void> {
        const ids: NumberishId[] = Array.isArray(mediumAvailabilityId) ? mediumAvailabilityId : [mediumAvailabilityId];

        return Promise.all(ids
            .map(id => this.apiClient.mediumAvailabilities_Id.patch(id, { _command: 'TOGGLE_RECOMMENDED', recommended }))
        ).then()
    }

    public deleteMany(offerId: string, criteria: {
        availabilityIds?: NumberishId[],
        customAreasInner?: Polygon[],
        customAreasOuter?: Polygon[]
    }): Promise<{ deletedCount: number }> {
        return this.apiClient.mediumAvailabilities.patch(offerId, {
            _command: 'DELETE_SOFTLY',
            ...criteria
        }).then(response => response.data) as Promise<{ deletedCount: number }>
    }

    public updateMany(offerId: string, availabilityIds: NumberishId[], fields: UpdatableFields): Promise<void> {
        return this.apiClient.mediumAvailabilities.patch(offerId, {
            _command: 'UPDATE',
            availabilityIds,
            fields
        }).then()
    }
}